<template>
  <div class="container">
    <div class="box" v-for="item in partner" :key="item.id">
      <div class="title">{{ item.title }}</div>
      <div>
        <el-image :src="item.imgUrl" :z-index="1"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Partner",
  components: {},
  data() {
    return {
      partner: [
        { id: 1001, title: "银行", imgUrl: require("./img/bank.jpg") },
        { id: 1002, title: "第三方支付", imgUrl: require("./img/pay.jpg") },
        { id: 1003, title: "证券/保险", imgUrl: require("./img/than.jpg") },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.container {
  box-sizing: border-box;
  padding: 40px;
  margin: 90px auto 20px auto;
  width: 980px;
  background-color: #fff;
  .box {
    margin-bottom: 60px;

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #0c6fb5;
      line-height: 18px;
      padding-left: 20px;
      background: url("~@/assets/arrow.png") no-repeat center left;
      margin-bottom: 20px;
    }
  }
}
</style>
